export class ListNotebooksRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListNotebooksFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortNotebookBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListNotebooksRequest.attributeTypeMap;
    }
    constructor() {
    }
}
